export function delay(ms) {
    return new Promise(resolve => {
        setTimeout(() => resolve(), ms);
    });
}
export function isInfoActivity(activity) {
    return activity.type === 'info';
}
export function joinPath(base, path) {
    if (base.endsWith('/')) {
        base = base.slice(0, -1);
    }
    if (/^\.?\//.test(path)) {
        path = path.slice(1);
    }
    return `${base}/${path}`;
}
export function makeTimeString(seconds) {
    let h;
    let m;
    let s;
    s = Math.round(seconds);
    h = Math.floor(s / 3600);
    s %= 3600;
    m = Math.floor(s / 60);
    s %= 60;
    if (m < 10)
        m = `0${m}`;
    if (s < 10)
        s = `0${s}`;
    let time = `${m}:${s}`;
    if (h > 0) {
        time = `${h}:${time}`;
    }
    return time;
}
